export default __webpack_public_path__ + "static/media/a023-startup5-en.bbf97d77.png";